import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import Pagination from "../utils/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
  faFilter, // Add this for the filter icon
  faTimes, // Add this for the "x" icon in filter tags
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import logo from "../buckland.png";
//Componentes de Reporte
import EnAbandono from "./CustomeAirBookingAbandonoGrid"
import EnEsperaComplemento from "./CustomerAirBookingComplementoGrid"
import Liberadas from "./CustomerAirBookingLiberadasGrid"
import Pendientes from "./CustomerAirBookingPendientesGrid"
import Subdivision from "./CustomerAirBookingSubdivisionGrid"
import General from "./CustomAirBookingGeneralGrid"
import {
  faBuilding,
  faIndustry,
  faUserTie,
  faPlane,
  faKey,
  faMapMarkerAlt,
  faInfoCircle,
  faClipboardCheck,
  faSearch,        
  faCalendarAlt,   
  faFileExport,    
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getTranslation } from "../utils/i18n"; // Import the getTranslation function
import {FormatLocalDateStringBorder} from "../utils/dateFormat"

const CustomerReportAirBookingGrid = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState("en");
  const { logout, customerNumbers } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const [allItems, setAllItems] = useState([]);
  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(200);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filterVisible, setFilterVisible] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "" });
  const [activeTab, setActiveTab] = useState("reporte1");
  const [globalSearch, setGlobalSearch] = useState("");

    const [selectStates, setSelectStates] = useState({});
  const [filters, setFilters] = useState({
    bookingCode: [],
    clienteRazonSocial: [],
    planta: [],
    division: [],
    numeroBolMaster: [],
    aduana: [],
    clavePedimento: [],
    bookingStatus: [],
    statusGuia: [],
  });

  const fieldIcons = {
    clienteRazonSocial: faBuilding,
    planta: faIndustry,
    division: faBuilding,
    numeroBolMaster: faPlane,
    aduana: faMapMarkerAlt,
    clavePedimento: faKey,
    bookingStatus: faClipboardCheck,
    statusGuia: faInfoCircle,
  };
  const selectOptions = useMemo(() => {
    const fields = [
      "bookingCode",
      "clienteRazonSocial",
      "numeroBolMaster",
      "proveedor",
      "clavePedimento",
      "planta",
      "division",
      "aduana",
      "bookingStatus",
      "statusGuia",
    ];

    return fields.reduce(
      (acc, field) => ({
        ...acc,
        [field]: [...new Set(allItems.map((item) => item[field]))].map(
          (value) => ({ value, label: value })
        ),
      }),
      {}
    );
  }, [allItems]);

  useEffect(() => {
    fetchData();
  }, [activeTab]);



  useEffect(() => {
    let filteredItems = allItems.filter((item) =>
      Object.entries(filters).every(([key, selectedOptions]) => {
        if (key === 'status' && activeTab === 'reporte6') return true;
        return (
          selectedOptions.length === 0 ||
          selectedOptions.some((option) => option.value === item[key])
        );
      })
    );

    // Búsqueda general
    if (globalSearch.trim() !== "") {
      const searchTerm = globalSearch.toLowerCase();
      filteredItems = filteredItems.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchTerm)
        )
      );
    }
    const sortedItems = sortConfig.key
      ? sortItems([...filteredItems])
      : filteredItems;

    setTotalPages(Math.ceil(sortedItems.length / pageSize));
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    setItems(sortedItems.slice(firstPageIndex, lastPageIndex));
  }, [allItems, currentPage, pageSize, filters, sortConfig, activeTab, globalSearch]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filters]);

  useEffect(() => {
    if (items.length) {
      let sortedItems = sortItems([...items]);
      setItems(sortedItems);
    }
  }, [sortConfig]);

  const toggleFilters = () => {
    setFilterVisible(!filterVisible);
  };

  const clearAllFilters = () => {
    setFilters((prev) => {
      const newFilters = {};
      for (const [key, value] of Object.entries(prev)) {
        if (key === "statusGuia" && isStatusFilterLocked) {
          newFilters[key] = value;
        } else {
          newFilters[key] = [];
        }
      }
      return newFilters;
    });
    setGlobalSearch(""); // <-- Limpiar búsqueda general
  };


  const renderHeader = () => (
    <div
      className="w-full flex flex-col px-2 md:px-4 py-2 md:py-4"
      style={{ backgroundColor: "#1A2654" }}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <div className="flex items-center">
            <img src={logo} alt="Company Logo" className="h-16 mr-2" />
          </div>
        </div>
        <div className="ml-auto flex items-center">
          <h1 className="text-xl font-semibold text-white mr-4">AWB Tracker Report</h1>
          <button
            onClick={handleLogout}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            {getTranslation(language, "logout")}
          </button>
          <select
            onChange={(e) => setLanguage(e.target.value)}
            value={language}
            className="ml-4 bg-gray-200 border border-gray-400 rounded-md py-1 px-2"
          >
            <option value="en">English</option>
            <option value="es">Español</option>
          </select>
        </div>
      </div>

      {/* Aquí agregamos las tabs */}
      <div className="mt-4 flex border-b border-gray-300">
        {[
          { id: "reporte1", label: "En Abandono" },
          { id: "reporte2", label: "Guias Liberadas" },
          { id: "reporte3", label: "Subdivisiones y Abandonos" },
          { id: "reporte4", label: "En Espera de Complemento" },
          { id: "reporte5", label: "Pendiente" },
          { id: "reporte6", label: "AWB Tracker Summary" },
        ].map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`py-2 px-4 -mb-px font-semibold border-b-2 ${activeTab === tab.id
                ? "border-blue-600 text-blue-200"
                : "border-transparent text-gray-300 hover:text-blue-200"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );

  const renderSelectFilters = ({ isDisabled }) => {

    const getActiveFiltersCount = () => {
      return Object.values(filters).reduce((count, filterArray) => count + filterArray.length, 0);
    };

    const toggleSelectDropdown = (name) => {
      setSelectStates(prev => ({
        ...prev,
        [name]: !prev[name]
      }));
    };

    const CustomSelect = ({ name, label, options, value, onChange, icon, placeholder, disabled }) => {
      const [searchTerm, setSearchTerm] = useState("");
      const isOpen = selectStates[name] || false;

      const filteredOptions = options.filter(option =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
      );

      const handleSelect = (option) => {
        const isSelected = value.some(v => v.value === option.value);
        if (isSelected) {
          onChange(value.filter(v => v.value !== option.value));
        } else {
          onChange([...value, option]);
        }
      };

      return (
        <div className="relative">
          <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center space-x-2">
            <FontAwesomeIcon icon={icon} className="text-blue-600 text-sm" />
            <span>{label}</span>
          </label>
          <div className="relative">
            <button
              onClick={() => !disabled && toggleSelectDropdown(name)}
              disabled={disabled}
              className={`w-full flex items-center justify-between px-3 py-2 border rounded-md bg-white text-sm ${disabled
                  ? 'border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed'
                  : 'border-gray-300 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                }`}
            >
              <span className="text-gray-500 truncate">
                {value.length > 0 ? `${value.length} selected` : placeholder}
              </span>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`text-gray-400 text-xs transition-transform ${isOpen ? 'rotate-180' : ''}`}
              />
            </button>

            {isOpen && !disabled && (
              <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-hidden">
                <div className="p-2 border-b">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div className="max-h-48 overflow-y-auto">
                  {filteredOptions.map((option) => {
                    const isSelected = value.some(v => v.value === option.value);
                    return (
                      <div
                        key={option.value}
                        onClick={() => handleSelect(option)}
                        className={`px-3 py-2 cursor-pointer hover:bg-gray-50 flex items-center space-x-2 text-sm ${isSelected ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                          }`}
                      >
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => { }}
                          className="text-blue-600 focus:ring-blue-500"
                        />
                        <span>{option.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    };

    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
        <div className="px-6 py-4">
          {/* Barra de búsqueda principal */}
          <div className="flex items-center space-x-4 mb-4">
            <div className="flex-1 relative">
              <FontAwesomeIcon
                icon={faSearch}
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"
              />
              <input
                type="text"
                value={globalSearch}
                onChange={(e) => setGlobalSearch(e.target.value)}
                placeholder="Search airwaybills, customers, references..."
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
              />
            </div>

            {/* Botones de acción */}
            <div className="flex items-center space-x-2">
              <button
                onClick={toggleFilters}
                className={`flex items-center space-x-2 px-4 py-2 rounded-md border text-sm font-medium transition-colors ${filterVisible
                    ? 'bg-blue-50 border-blue-200 text-blue-700'
                    : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
                  }`}
              >
                <FontAwesomeIcon icon={faFilter} className="text-sm" />
                <span>Filters</span>
                {getActiveFiltersCount() > 0 && (
                  <span className="bg-blue-600 text-white text-xs px-2 py-0.5 rounded-full">
                    {getActiveFiltersCount()}
                  </span>
                )}
              </button>
              {/* Filtros de fechas
                <button className="flex items-center space-x-2 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 text-sm font-medium">
                <FontAwesomeIcon icon={faCalendarAlt} className="text-sm" />
                <span>Date Range</span>
                <FontAwesomeIcon icon={faChevronDown} className="text-xs" />
                </button>
            */}

            </div>
          </div>

          {/* Filtros avanzados colapsables */}
          {filterVisible && (
            <div className="border-t pt-4">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-sm font-medium text-gray-700 flex items-center space-x-2">
                  <FontAwesomeIcon icon={faFilter} className="text-blue-600" />
                  <span>Advanced Filters</span>
                </h3>
                {getActiveFiltersCount() > 0 && (
                  <button
                    onClick={clearAllFilters}
                    className="text-sm text-red-600 hover:text-red-800 underline"
                  >
                    Clear all filters
                  </button>
                )}
              </div>

               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
            {[
              { name: "clienteRazonSocial", label: "Customer" },
              { name: "planta", label: "Planta" },
              { name: "division", label: "Division" },
              { name: "numeroBolMaster", label: "Airwaybill Master" },
              { name: "clavePedimento", label: "Pedimento Type" },
              { name: "aduana", label: "Entry Point" },
              { name: "statusGuia", label: "Status" },
              { name: "bookingStatus", label: "Booking Status" },
            ].map(({ name, label }) => (  <div className="filter-group" key={name}>
                <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center space-x-2">
                  <FontAwesomeIcon icon={fieldIcons[name]} className="text-blue-600 text-xs md:text-sm" />
                  <span>{label}</span>
                </label>
                          <Select
                  isMulti
                  isDisabled={name === "statusGuia" && isDisabled}
                  isClearable={!(name === "statusGuia" && isDisabled)}
                  name={name}
                  options={selectOptions[name]}
                  className="basic-multi-select text-sm"
                  classNamePrefix="select-filter"
                  menuPortalTarget={document.body}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '30px',
                    height: '30px',
                    fontSize: '12px',
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: '30px',
                    padding: '0 6px',
                  }),
                  input: (base) => ({
                    ...base,
                    margin: '0px',
                  }),
                  indicatorsContainer: (base) => ({
                    ...base,
                    height: '30px',
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                onChange={(selectedOptions) =>
                  setFilters((prev) => ({
                    ...prev,
                    [name]: selectedOptions || [],
                  }))
                }
                value={filters[name]}
                placeholder={`Filter by ${label}`}
              />
              </div>
                ))}</div>

              {/* Tags de filtros activos */}
              {getActiveFiltersCount() > 0 && (
                <div className="flex flex-wrap gap-2">
                  {Object.entries(filters).map(([key, selectedOptions]) =>
                    selectedOptions.map((item) => (
                      <span
                        key={`${key}-${item.value}`}
                        className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full"
                      >
                        <span className="capitalize">{key.replace(/([A-Z])/g, ' $1').trim()}:</span>
                        <span>{item.label}</span>
                        {!(key === "statusGuia" && isDisabled) && (
                          <button
                            onClick={() =>
                              setFilters((prev) => ({
                                ...prev,
                                [key]: prev[key].filter((i) => i.value !== item.value),
                              }))
                            }
                            className="ml-1 text-blue-600 hover:text-blue-800"
                          >
                            <FontAwesomeIcon icon={faTimes} className="text-xs" />
                          </button>
                        )}
                      </span>
                    ))
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };
  const getAllFilteredItems = () => {
    return allItems.filter((item) =>
      Object.entries(filters).every(
        ([key, selectedOptions]) =>
          selectedOptions.length === 0 ||
          selectedOptions.some((option) => option.value === item[key])
      )
    );
  };

  const sortItems = (itemsToSort) => {
    const { key, direction } = sortConfig;
  if (!key) return itemsToSort;

  return [...itemsToSort].sort((a, b) => {
    const valA = a[key] ?? "";
    const valB = b[key] ?? "";

    if (valA < valB) return direction === "ascending" ? -1 : 1;
    if (valA > valB) return direction === "ascending" ? 1 : -1;
    return 0;
  });
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    } else {
      direction = "ascending";
    }
    setSortConfig({ key, direction });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    const accessToken = localStorage.getItem("accessToken");
    console.log(accessToken)
    if (!accessToken) {
      setError("Access token is not available");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/api/bookings/air/report`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      function formatDate(fecha) {
        return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
      }

      function calcularDiasAlmacenaje(diff) {
        if (diff > 0) {
          return diff;
        } else if (diff === 0) {
          return "0";
        } else {
          return '-';
        }
      }
      
      function calcularCostoAlmacenaje(peso, diasAlmacenaje) {
        let factor = 0;

        if (peso <= 0 ) {
          factor = 0;
        } else if (peso <= 100 ) {
          factor = 1.77;
        } else if (peso <= 200) {
          factor = 1.21;
        } else if (peso <= 300) {
          factor = 1.05;
        } else if (peso <= 500) {
          factor = 0.85;
        } else
        {
          return factor;
        }
        return factor * peso * diasAlmacenaje;
      }

      const transformedData = response.data.map(item => {
        const hoy = new Date();
        const fechaArribo = item.fechaArribo ? new Date(item.fechaArribo) : null;
        const fechaModulacion = item.NETData?.FECHA_MODULACION ? new Date(item.NETData.FECHA_MODULACION) : null;
        const fechaPago = item.NETData?.M3_FECHAPAGO ? new Date(item.NETData?.M3_FECHAPAGO) : null;
        const fechaETA = item.fechaETA?.[item.fechaETA.length - 1]?.fechaETA ? new Date(item.fechaETA[item.fechaETA.length - 1].fechaETA): null;
        const fechaInicioAlmacenaje = fechaETA ? new Date(fechaETA.getTime() + 2 * 24 * 60 * 60 * 1000).toLocaleDateString(): '-';
        const aduanaPedimento = item.NETData?.NET_ADUANA ? item.NETData?.NET_ADUANA : item.aduana;

        //Calculos de los dias de almacenaje
        //Dias Almacenaje Libres
        let diasAlmacenaje = "-";
        let diasAlmacenajeLibres = '-';  
        if (fechaETA) {
          const etaSinHora = formatDate(fechaETA);
          if (!fechaModulacion) {
              const hoySinHora = formatDate(hoy);
              const diff = Math.floor((hoySinHora - etaSinHora) / (1000 * 60 * 60 * 24));
              diasAlmacenaje = calcularDiasAlmacenaje(diff);
          } else {
              const modulacionSinHora = formatDate(fechaModulacion);
              const diff = Math.floor((modulacionSinHora - etaSinHora) / (1000 * 60 * 60 * 24));
              diasAlmacenaje = calcularDiasAlmacenaje(diff);
          }
        } 

        // Dias de almacenaje sin incluir dias libres ( 2 DIAS por default)
        if (typeof diasAlmacenaje === 'number') {
          const diaslibres = Math.max(diasAlmacenaje - 2, 0);
          diasAlmacenajeLibres = diaslibres; 
        }
        
        //Calculo de costos de almacenaje en base al Peso , Dias de Almacenaje
        const peso = (Number( item.NETData?.PESO_LBS)  * 0.453592 ) || 0;
        const dias = typeof diasAlmacenaje === 'number' ? diasAlmacenaje : 0;
        const costoAlmacenaje = calcularCostoAlmacenaje(peso, dias);

        return ({
          id: item._id,
          bookingCode: item.bookingCode || '-',
          bookingUser: item.creadoPor || '-',
          bookingStatus: item.status?.[item.status.length - 1]?.status || '-',
          numeroBolMaster: item.bolMaster?.[0]?.numeroBolMaster || '-',
          bolHouse: item.bolMaster?.[0]?.bolHouse?.[0]?.numeroBolHouse || '-',
          modal: item.modal || '-',
          statusGuia: item.estadoAereo || 'N/A',
          division: item.planta || '-',
          //Trafico
          referencia: item.referencia || '-',
          planta: item.NETData?.PLANTA_DESTINO || '-',
          clienteRazonSocial: item.cliente?.razonSocial || '-',
          proveedor: item.NETData?.PROVEEDOR || '-',
          aduana: aduanaPedimento || '-',
          clavePedimento: item.NETData?.CLAVE_PEDIMENTO || '-',
          pedimento: `${aduanaPedimento?.slice(0, 2) || 'PENDIENTE'}  ${item.NETData?.PEDIMENTO_COMPLETO?.replace('-', ' ') || ''}`,
          tipoPedimento: item.bolMaster?.[0]?.informacionTrafico?.NET_TIPOPEDIMENTO || '-',
          
          remesaPedimento: item.NETData?.REMESA || '-',
          carrier: item.NETData?.CARRIER || '-',
          bultos: item.NETData?.BULTOS || '-',          
          peso: peso.toFixed(5).toString() ,
          noFactura: item.NETData?.FACTURA || '-',
          incotermFactura: item.NETData?.INCOTERM || '-',
          noParte: item.NETData?.NUMPARTE || '-',
          cantidadParte: item.NETData?.CANTIDAD_NUMPARTE || '-',          
          //Fechas
          fechaModulacion: fechaModulacion ? FormatLocalDateStringBorder(fechaModulacion) : "-",
          fechaETA: fechaETA ? fechaETA.toLocaleDateString("en-US") : "-",
          fechaPago: fechaPago ? FormatLocalDateStringBorder(fechaPago) : "-",
          fechaArribo: fechaArribo ? fechaArribo.toLocaleDateString() : '-',
          //Campos adicionales para Guias                
          estadoModulacion: item.NETData?.ESTADO_MODULACION || '-',
          usuario: item.usuarioSeguimiento || '-',
          observaciones: item.observaciones || '',
          contactoWisdom: '-',
          //Costos de Almacenaje
          almacenajes: "$" + costoAlmacenaje.toFixed(2).toString(),
          dias: diasAlmacenaje ,
          diasAlmacenaje: diasAlmacenajeLibres.toString(),
          inicioAlmacenaje: fechaInicioAlmacenaje        
          
        });
      });


      setAllItems(transformedData);
      setTotalPages(Math.ceil(transformedData.length / pageSize));
      setIsLoading(false);
    } catch (error) {
      setError("Failed to fetch data");
      setIsLoading(false);
      console.error("Failed to fetch data:", error);
    }
  };
  useEffect(() => {
  const statusPorTab = {
    reporte1: "Abandono", // En Abandono
    reporte2: "Liberada", // Guías Liberadas 
    reporte3: "Subdivision y Abandono", // Subdivisiones y Abandonos
    reporte4: "En espera de Complemento", // En Espera de Complemento
    reporte5: "Pendiente", // Pendientes
    // reporte6 (General) no tiene filtro
  };

  const statusValue = statusPorTab[activeTab];

  if (statusValue && activeTab !== "reporte6") {
    // Solo aplicar filtro de status si la pestaña tiene un status definido y NO es General
    setFilters((prev) => ({
      ...prev,
      statusGuia: [{ label: statusValue, value: statusValue }],
    }));
  } else if (activeTab === "reporte6") {
    // Para la pestaña General, limpiar el filtro de status pero mantener los demás
    setFilters((prev) => ({
      ...prev,
      statusGuia: [], // Sin filtro de status para mostrar todos los estados
    }));
  }
}, [activeTab]);

const lockedTabs = ["reporte1", "reporte2", "reporte3", "reporte4", "reporte5"];
const isStatusFilterLocked = lockedTabs.includes(activeTab);

const renderPagination = () => (
    <Pagination
      total={totalPages * pageSize}
      pageSize={pageSize}
      currentPage={currentPage}
      onPageChange={(page) => setCurrentPage(page)}
      onPageSizeChange={(size) => {
        setPageSize(size);
        setCurrentPage(1);
      }}
    />
  );

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <FontAwesomeIcon
          icon={faSpinner}
          className="text-xl font-semibold animate-spin"
        />
        <div className="text-xl font-semibold ml-2">Loading...</div>
      </div>
    );
  }
  
  if (error) return <div>Error: {error}</div>;

 return (
    <>
      {renderHeader()}
      <div
        className="container mx-auto px-4 sm:px-8 py-8 bg-gray-100"
        style={{ maxWidth: "100%" }}
      >
        {activeTab === "reporte1" && (
          <EnAbandono
              allItems={items}
            filters={filters}
            setFilters={setFilters}
            sortConfig={sortConfig}
            requestSort={requestSort}
            renderSelectFilters={() => renderSelectFilters({ isDisabled: isStatusFilterLocked })}
            renderPagination={renderPagination}
          />
        )}

        {activeTab === "reporte2" && (
           <Liberadas
              allItems={items}
              filters={filters}
              setFilters={setFilters}
              sortConfig={sortConfig}
              requestSort={requestSort}
              renderSelectFilters={() => renderSelectFilters({ isDisabled: isStatusFilterLocked })}
              renderPagination={renderPagination}
          />
        )}

        {activeTab === "reporte3" && (
           <Subdivision
              allItems={items}
              filters={filters}
              setFilters={setFilters}
              sortConfig={sortConfig}
              requestSort={requestSort}
              renderSelectFilters={() => renderSelectFilters({ isDisabled: isStatusFilterLocked })}
              renderPagination={renderPagination}
          />
        )}

        {activeTab === "reporte4" && (
           <EnEsperaComplemento
              allItems={items}
              filters={filters}
              setFilters={setFilters}
              sortConfig={sortConfig}
              requestSort={requestSort}
              renderSelectFilters={() => renderSelectFilters({ isDisabled: isStatusFilterLocked })}
              renderPagination={renderPagination}
          />
        )}

        {activeTab === "reporte5" && (
           <Pendientes
            allItems={items}
              filters={filters}
              setFilters={setFilters}
              sortConfig={sortConfig}
              requestSort={requestSort}
              renderSelectFilters={() => renderSelectFilters({ isDisabled: isStatusFilterLocked })}
              renderPagination={renderPagination}
          />
        )}

        {activeTab === "reporte6" && (
          <General
           allItems={allItems} // Datos completos 
           items={items}
           filters={filters}
           setFilters={setFilters}
           sortConfig={sortConfig}
           requestSort={requestSort}
           renderSelectFilters={() => renderSelectFilters({ isDisabled: false })}
           renderPagination={renderPagination}
          />
        )}


      </div>
    </>
  );
};

export default CustomerReportAirBookingGrid;